import { render, staticRenderFns } from "./PreList.vue?vue&type=template&id=633f9d44&scoped=true"
import script from "./PreList.vue?vue&type=script&lang=js"
export * from "./PreList.vue?vue&type=script&lang=js"
import style0 from "./PreList.vue?vue&type=style&index=0&id=633f9d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633f9d44",
  null
  
)

export default component.exports